import { actions as archivedJobActions } from '@saucelabs/sl-module-archived-jobs';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as queryOperations from './../query/operations';
import * as queryActions from './../query/actions';
import * as columnsActions from './../columns/actions';

export const initialize = ({
  user,
  isArchivesV2Enabled,
}) => async (dispatch) => {
  await dispatch(queryActions.getTeamList());
  // before we will call 'query from URL', we have to fetch all async filters first
  await dispatch(queryOperations.getQueryFromURL({ isArchivesV2Enabled }));

  const getUsersParams = !user.isOrgAdmin() ? { team_id: user.getUserTeamId() } : {};

  // bootstrap the view
  return Promise.all([
    dispatch(columnsActions.getColumns()),
    dispatch(actions.getUsers(getUsersParams)),
    dispatch(archivedJobActions.getSavedQueries()),
  ])
    .then(() => (
      Promise.all([
        dispatch(actions.initialize()),
        dispatch(queryOperations.search({ isArchivesV2Enabled })),
      ])
    ));
};

export const saveQuery = (query) => (dispatch) => {
  if (!query) {
    return dispatch(notificationActions.notifyDanger('You can\'t save an empty query.'));
  }

  return dispatch(archivedJobActions.saveQuery(query))
    .then(() => dispatch(notificationActions.notifySuccess('Your query has been saved!')))
    .catch((err) => {
      if (err?.response?.data) {
        const { detail, message } = err.response.data;
        return dispatch(notificationActions.notifyDanger(detail, message));
      }

      return dispatch(notificationActions.notifyDanger('We couldn\'t save your query.'));
    });
};

export const deleteSavedQuery = (id) => (dispatch) => (
  dispatch(archivedJobActions.deleteQuery(id))
    .then(() => {
      dispatch(notificationActions.notifySuccess('You deleted query!'));
      return dispatch(archivedJobActions.getSavedQueries());
    })
    .catch((err) => {
      if (err?.response?.data) {
        const { detail, message } = err.response.data;
        return dispatch(notificationActions.notifyDanger(detail, message));
      }

      return dispatch(notificationActions.notifyDanger('We couldn\'t delete selected query.'));
    })
);

export const toggleJobSelection = (payload) => (dispatch) => {
  dispatch(actions.toggleJobSelection(payload));
};

export const setJobSelection = (payload) => (dispatch) => {
  dispatch(actions.setJobSelection(payload));
};

export const clearJobSelection = (payload) => (dispatch) => {
  dispatch(actions.clearJobSelection(payload));
};

export const removeJobs = (payload, isArchivesV2Enabled) => async (dispatch) => {
  /* eslint camelcase: 0 */
  await dispatch(queryActions.resetPage());
  await dispatch(archivedJobActions.remove({ data: { job_ids: payload } }));
  dispatch(actions.clearJobSelection(payload));
  return dispatch(queryOperations.search({ isArchivesV2Enabled }));
};
